const compositeScoresService = require('./src/composite_score_service');
const gatingRulesService = require('./src/gating_rules_service');

module.exports = {
    compositeScoresService,
    gatingRulesService,
};
